import axios from "axios";
import authHeader from "../../helpers/header";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import Dropdown from 'react-bootstrap/Dropdown';
import { setMessage } from "../../redux/actions/message";
import AuthLayout from "../../components/AuthLayout/AuthLayout";
import ResourceAPI from "../../api/resourceAPI";
import { API_URL, MEDIA_URL, OPENAI_KEY, GEMINI_KEY } from "../../configs";
import promptsData from '../../data/social-prompts.json';

// import { setMessage } from "../../redux/actions/message";
// import AuthLayout from "../../components/AuthLayout/AuthLayout";
// import ResourceAPI from "../../api/resourceAPI";
// import { API_URL, MEDIA_URL, OPENAI_KEY } from "../../configs";
// import promptsData from '../../data/social-prompts.json';


// Copy button components from ResourcesImageProcess.js

// Copy button components from ResourcesImageProcess.js
const InputWithCopyButton = ({ initialText, onReplaceLink }) => {
    const [text, setText] = useState(initialText);
    const [isCopied, setIsCopied] = useState(false);
    const handleCopyClick = () => {
      const input = document.createElement('input');
      input.value = text;
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setIsCopied(true);
      setTimeout(() => { setIsCopied(false); }, 2000);
    };
    const handleTextChange = (event) => { setText(event.target.value); };
    return (
      <div className="d-flex g-3 align-items-center">
        <input type="text" className="form-control form-control-sm" value={text} onChange={handleTextChange} />
        <button className="btn btn-light btn-sm" onClick={handleCopyClick} disabled={isCopied}>
            {isCopied ? <i className="bi bi-check text-white"></i> : <i className="bi bi-clipboard"></i>}
        </button>
        <button className="btn btn-light btn-sm" title="Replace Download Link" onClick={() => onReplaceLink && onReplaceLink(text)}>
          <i className="bi bi-link-45deg"></i>
        </button>
      </div>
    );
};



const defaultSocialNetworks = ['Facebook', 'Twitter', 'Instagram', 'LinkedIn', 'Tumblr'];


function ResourcesSocial(props) {
    const {
      register,
      handleSubmit,
      setValue,
      getValues,
      watch,
      formState: { errors },
    } = useForm();

    const dispatch = useDispatch();
    const { message, messageType } = props;
    const search = useLocation().search
    const searchParams = new URLSearchParams(search)
    //const [imageUrl, setImageUrl] = useState(null);
    const [data, setData] = useState([]);
    const [selectedNetworks, setSelectedNetworks] = useState(defaultSocialNetworks);

    const [prompt, setPrompt] = useState('');
    const [imageUrl, setImageUrl] = useState('');
    const [generating, setGenerating] = useState(false)
    const [selectedId, setSelectedId] = useState([]);
    const [selectedThumbnails, setSelectedThumbnails] = useState([]);
    const [generatedData, setGeneratedData] = useState(null);

    // Handle checkbox change
    const handleCheckboxChange = (network) => {
      if (selectedNetworks.includes(network)) {
          setSelectedNetworks(selectedNetworks.filter((n) => n !== network));
      } else {
          setSelectedNetworks([...selectedNetworks, network]);
      }
    };

    // Image downloader function (uses selectedThumbnails)
    const handleDownload = async (ratio = "9:16") => {
      // Parse the ratio string, e.g., "4:5" becomes widthRatio = 4 and heightRatio = 5
      const [widthRatio, heightRatio] = ratio.split(":").map(Number);
      for (let i = 0; i < selectedThumbnails.length; i++) {
        let pictureUrl = selectedThumbnails[i];
        let output = `${ratio.replace(':', 'x')}_resource_${i+1}`;
        const response = await fetch(`${pictureUrl}`);
        const blob = await response.blob();
        const img = document.createElement('img');
        img.src = URL.createObjectURL(blob);
        img.onload = () => {
          const imageWidth = img.width;
          const imageHeight = img.height;
          const imageAspectRatio = imageWidth / imageHeight;
          const targetAspectRatio = widthRatio / heightRatio;
          let canvasWidth, canvasHeight;
          if (imageAspectRatio > targetAspectRatio) {
            canvasWidth = imageWidth;
            canvasHeight = imageWidth * (heightRatio / widthRatio);
          } else {
            canvasHeight = imageHeight;
            canvasWidth = imageHeight * (widthRatio / heightRatio);
          }
          const canvas = document.createElement('canvas');
          canvas.width = canvasWidth;
          canvas.height = canvasHeight;
          const ctx = canvas.getContext('2d');
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, canvasWidth, canvasHeight);
          const offsetX = (canvasWidth - imageWidth) / 2;
          const offsetY = (canvasHeight - imageHeight) / 2;
          ctx.drawImage(img, offsetX, offsetY, imageWidth, imageHeight);
          canvas.toBlob((newBlob) => {
            let url = window.URL.createObjectURL(newBlob);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${output}.jpg`;
            a.click();
          }, 'image/jpeg', 0.9);
        };
      }
    };

    // Generate the JSON output format based on selected networks
    const generateSocialJson = () => {
      const socialJson = { post: {} };
      
      selectedNetworks.forEach((network) => {
          socialJson.post[network] = { content: "" };
      });
      return JSON.stringify(socialJson, null, 2); // Format JSON with indentation
  };


    // Function to generate with ChatGPT (OpenAI)
    const generateWithChatGPT = async (promptText, msg_content) => {
      try {
        setGenerating(true);
        const response = await fetch('https://api.openai.com/v1/chat/completions', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${OPENAI_KEY}`,
          },
          body: JSON.stringify({
            model: 'gpt-4o-mini',
            messages: [
              { role: 'system', content: 'You are a helpful assistant.' },
              {
                role: 'user',
                content: msg_content
              },
            ],
            response_format: { type: "json_object" },
          }),
        });
        const completion = await response.json();
        const { content } = completion.choices[0].message;
        const parsedData = JSON.parse(content.replace(/`/g, '').replace('json', ''));
        setGeneratedData(parsedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setGenerating(false);
      }
    };

    // Function to generate with Gemini (Google)
    const generateWithGemini = async (promptText, msg_content) => {
      try {
        setGenerating(true);
        // Use GEMINI_KEY from configs or env
        // const GEMINI_KEY = process.env.REACT_APP_GEMINI_KEY || '';


        const geminiUrl = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent';

        // Gemini expects a 'contents' array with text and/or image parts
        // If you want to send images, you must convert them to base64 and set mime_type
        // See Gemini API docs for details
        let parts = [];
        // Fetch and add images as inline_data (base64)
        if (selectedThumbnails && selectedThumbnails.length > 0) {
          for (let url of selectedThumbnails) {
            try {
              const res = await fetch(url);
              const blob = await res.blob();
              const arrayBuffer = await blob.arrayBuffer();
              const base64String = btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));
              const mimeType = blob.type || 'image/png';
              parts.push({ inline_data: { mime_type: mimeType, data: base64String } });
            } catch (err) {
              console.error('Failed to fetch/convert image for Gemini:', url, err);
            }
          }
        }
        // Add the text part last
        parts.push({ text: promptText });
        const contents = [ { parts } ];
        const response = await fetch(geminiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-goog-api-key': GEMINI_KEY,
          },
          body: JSON.stringify({
            contents,
            // generationConfig: { response_mime_type: 'application/json' }, // Optional
          }),
        });
        const result = await response.json();
        // Gemini returns text in candidates[0].content.parts[0].text
        const text = result.candidates && result.candidates[0] && result.candidates[0].content && result.candidates[0].content.parts[0].text;
        if (text) {
          // Remove code fences and whitespace if present
          let cleaned = text.trim();
          if (cleaned.startsWith('```json')) cleaned = cleaned.replace(/^```json/, '');
          if (cleaned.startsWith('```')) cleaned = cleaned.replace(/^```/, '');
          if (cleaned.endsWith('```')) cleaned = cleaned.replace(/```$/, '');
          cleaned = cleaned.trim();
          try {
            const parsedData = JSON.parse(cleaned);
            setGeneratedData(parsedData);
          } catch (err) {
            console.error('Gemini JSON parse error:', err, cleaned);
            dispatch(setMessage('Gemini returned invalid JSON', 'danger'));
          }
        } else {
          dispatch(setMessage('No data returned from Gemini', 'danger'));
        }
      } catch (error) {
        console.error('Error fetching data from Gemini:', error);
        dispatch(setMessage('Error fetching data from Gemini', 'danger'));
      } finally {
        setGenerating(false);
      }
    };

    // Main handler: switch between ChatGPT and Gemini
    const handleGenerateData = async () => {
      const promptText = prompt || `Generate a title, description, and tags for the image located at: ${imageUrl}`;
      setGeneratedData(null); // Clear previous generated content
      let msg_content = [ { type: 'text', text: promptText } ];
      if (selectedThumbnails.length > 0) {
        selectedThumbnails.forEach((url) => {
          msg_content.push({ type: 'image_url', image_url: { url } });
        });
      } else {
        dispatch(setMessage(`Please select a resource`, 'danger'));
        return;
      }
      // By default, use Gemini for now. To switch, call generateWithChatGPT instead.
      await generateWithGemini(promptText, msg_content);
      // await generateWithChatGPT(promptText, msg_content); // Uncomment to use ChatGPT
    };

     // Handle checkbox change
    const handleIdChange = (e, imageUrl) => {
      const { checked, value } = e.target;

      if (checked) {
        // Add the ID to the selected list
        setSelectedId((prevSelectedId) => [...prevSelectedId, value]);

        // Add the image URL to the selected list
        setSelectedThumbnails((prevSelectedThumbnails) => [...prevSelectedThumbnails, imageUrl]);
      } else {
        // Remove the ID from the selected list
        setSelectedId((prevSelectedId) =>
          prevSelectedId.filter((id) => id !== value)
        );

        // Remove the image URL from the selected list
        setSelectedThumbnails((prevSelectedThumbnails) =>
          prevSelectedThumbnails.filter((url) => url !== imageUrl)
        );
      }
    };

    // Handle selected all
    const handleCheckAll = () => {
      if (selectedId.length === 0) {
        data.map((resource) => {
          setSelectedId((selectedId) => [...selectedId, resource._id]);
          return selectedId;
        });
      } else {
        setSelectedId([]);
      }
    };

    useEffect(() => {
        let ids = searchParams.get('resources_id');
        async function getResourcesImages(ids) {
            const res = await axios.get(API_URL + `resources/getbulk/?ids=${ids}`);
            if (res.status === 200) {
                setData(res.data);
                // If resources_id exists, set selectedId to the array of IDs
                if (ids) {
                    const idArr = ids.split(',').map(id => id.trim());
                    setSelectedId(idArr);
                    // Optionally, set selectedThumbnails for these resources
                    const thumbnails = res.data
                        .filter(item => idArr.includes(item._id))
                        .map(item => item.thumbnail ? `${MEDIA_URL}${item.thumbnail.path}` : '');
                    setSelectedThumbnails(thumbnails);
                }
            }
        }
        if (ids) {
            getResourcesImages(ids);
        }
        //setPrompt(`${MEDIA_URL}${data[0].thumbnail.path}`)
    }, [])

    useEffect(() => {
      const networkList = selectedNetworks.join(', ');
      const socialJson = generateSocialJson();

      if (data[0]) {
        setImageUrl(data[0].thumbnail ? `${MEDIA_URL}${data[0].thumbnail.path}` : '');

        // Build prompt from new social-prompts.json structure
        let promptParts = [];
        if (promptsData.role) promptParts.push(promptsData.role);
        // Replace [SOCIAL_NETWORK] in task with selectedNetworks
        if (promptsData.task) {
          const replacedTask = promptsData.task.replace('[SOCIAL_NETWORK]', networkList);
          promptParts.push(replacedTask);
        }
        if (promptsData.tone) promptParts.push('Tone: ' + promptsData.tone);
        if (promptsData.chain_of_thought_prompting && Array.isArray(promptsData.chain_of_thought_prompting)) {
          promptParts.push('Instructions:');
          promptsData.chain_of_thought_prompting.forEach((step, idx) => {
            promptParts.push(`${idx + 1}. ${step}`);
          });
        }
        if (promptsData.guidelines) {
          promptParts.push('Guidelines:');
          Object.entries(promptsData.guidelines).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              promptParts.push(`${key}: ${value.join(', ')}`);
            } else {
              promptParts.push(`${key}: ${value}`);
            }
          });
        }
        // promptParts.push('Output format:');
        // promptParts.push(JSON.stringify(promptsData.output_format, null, 2));
        // Optionally add sample_emotion_prompt
        // if (promptsData.sample_emotion_prompt) {
        //   promptParts.push('Sample emotion prompt: ' + promptsData.sample_emotion_prompt);
        // }
        // Add selected networks and output json for context
        promptParts.push('Selected networks: ' + networkList);
        promptParts.push('Output JSON template: ' + socialJson);
        setPrompt(promptParts.join('\n'));
      }
    }, [data, selectedNetworks]);

    return (
        <AuthLayout>
            <header className={"d-flex justify-content-between align-items-center mb-4"}>
                <h2 className="fs-5">{"Test Social Post generation (ChatGPT)"}</h2>
                <div className="d-flex">
                  <Dropdown className="me-2">
                    <Dropdown.Toggle variant="primary" id="dropdown-basic">
                        <i className="bi bi-download"></i>
                        <span className="ms-2">Download images</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handleDownload("1:1")}>Download 1:1 (Square)</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownload("4:5")}>Download 4:5 (Portrait)</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownload("9:16")}>Download 9:16 (Vertical)</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownload("4:3")}>Download 4:3 (Landscape)</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownload("16:9")}>Download 16:9 (Wide)</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
            </header>
            <div className="row">
              {/* Left column: resource selection and controls */}
              <div className="col-md-6">
                {data && 
                <>
                <div className="mb-4 flex">
                <button
                    className="btn bg-light px-3 btn-sm"
                    onClick={(e) => {
                      e.preventDefault();
                      handleCheckAll();
                    }}
                  >
                    {selectedId.length > 0 ? "Unselect all" : "Select all"}
                  </button>
                  {selectedId.length > 0 && (
                    <span className="small mx-4 text-muted">
                      {selectedId.length} {"selected"}
                    </span>
                  )}
                  </div>
                <div className="row mb-4">
                    {(() => {
                      // Filter only selected resources
                      const selectedResources = data.filter((item) => selectedId.includes(item._id));
                      // Chunk into rows of max 4
                      const rows = [];
                      for (let i = 0; i < selectedResources.length; i += 4) {
                        rows.push(selectedResources.slice(i, i + 4));
                      }
                      return rows.map((row, rowIdx) => (
                        <div className="d-flex mb-3" key={rowIdx}>
                          {row.map((data, index) => {
                            const thumbnailUrl = data.thumbnail ? `${MEDIA_URL}${data.thumbnail.path}` : '';
                            return (
                              <div key={index} className="flex-fill mx-2" style={{ maxWidth: '50%' }}>
                                <div className="d-flex flex-row justify-content-between align-items-center mb-2">
                                <input
                                  type="checkbox"
                                  value={data._id}
                                  className="form-check-input"
                                  {...register(`resource_id.${data._id}`)}
                                  onChange={(e) => handleIdChange(e, thumbnailUrl)}
                                  checked={selectedId.indexOf(data._id.trim()) > -1}
                                />
                                <span className="text-muted text-center mt-2 mb-1 py-0">
                                  <Link to={`/resources/view/${data._id}`} target="_blank" rel="noreferrer">
                                    <span className="me-2 mt-1 small text-break rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">{data._id}</span>
                                  </Link>
                                </span>
                                </div>
                                <img className="img-thumbnail" src={`${thumbnailUrl}`} style={{ width: '100%' }} />
                                <div className="mt-2 mb-1 py-0 d-flex align-items-center">{data.name}
                                {data.thumbnail &&
                                  <span className="text-muted text-center mb-2 py-0">
                                    <span className="me-2 mt-1 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2 text-uppercase">{data.thumbnail?.contentType}</span>
                                    <span className="me-2 mt-1 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">{data.thumbnail?.width}{' x '}{data.thumbnail?.height}</span>
                                  </span>
                                }
                                </div>
                                <InputWithCopyButton
                                  initialText={`https://magipik.com/vector/${data.slug}`}
                                  onReplaceLink={(link) => {
                                    // Replace [Download Link] or [Download Link in Bio] in generatedData
                                    if (!generatedData) return;
                                    const updated = { ...generatedData };
                                    selectedNetworks.forEach((net) => {
                                      if (updated.post[net]?.content) {
                                        updated.post[net].content = updated.post[net].content.replace(/\[Download Link Here]?\]/g, link);
                                      }
                                    });
                                    setGeneratedData(updated);
                                  }}
                                />
                                
                              </div>
                            );
                          })}
                        </div>
                      ));
                    })()}
                </div>
                </>
                }
                <div className="mb-4">
                <label className="form-label">
                            Select social network
                        </label><br />
                {defaultSocialNetworks.map((network) => (
                    <div key={network} className="form-check form-check-inline">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedNetworks.includes(network)}
                                onChange={() => handleCheckboxChange(network)}
                            />
                            <label className="form-check-label">
                            {network.charAt(0).toUpperCase() + network.slice(1)}
                        </label>
                    </div>
                ))}
                </div>
                <div className="mb-4">
                <label className="form-label">Prompt:</label>
                <textarea rows={5} 
                  type="text"
                  value={prompt}
                  className="form-control mb-2 input-sm"
                  onChange={(e) => setPrompt(e.target.value)}
                  placeholder="Enter or adjust the prompt"
                  style={{ width: '100%' }}
                >
                </textarea>
                <button className="btn btn-secondary" onClick={handleGenerateData}>Generate Data</button>
                <div className="mt-2 mb-3">
                  <small className="text-muted">
                    <strong>Recommended image sizes:</strong><br />
                    1080 x 1080 px (1:1 square) — safest for Instagram, Facebook, LinkedIn<br />
                    1080 x 1350 px (4:5 portrait) — works great for mobile-first scroll experiences (Instagram, LinkedIn)
                  </small>
                </div>
                </div>
                {
                  generating &&
                  <p className="alert alert-warning my-2">{'Your request is proccessing, please wait...!!!'}</p>
                }
                {message && (
                    <div className="mb-4">
                      <div className={`alert alert-${messageType}`} role="alert">
                        {message}
                      </div>
                    </div>
                )}
              </div>
              {/* Right column: Gemini result */}
              <div className="col-md-6">
                {generatedData && (
                  <div className="mb-4">
                    <h3>Generated Data</h3>
                    {selectedNetworks.map((net, index) => {
                      const content = generatedData.post[net]?.content || '';
                      return (
                        <div className="mb-3" key={index}>
                          <div className="d-flex align-items-center mb-2">
                            <strong className="text-muted me-2">{`${net} content:`}</strong>
                            <button
                              className="btn btn-outline-secondary btn-sm ms-auto"
                              style={{ fontSize: '0.9em' }}
                              onClick={() => {
                                navigator.clipboard.writeText(content);
                              }}
                              title="Copy to clipboard"
                            >
                              <i className="bi bi-clipboard"></i> Copy
                            </button>
                          </div>
                          <pre
                            className="bg-light p-3 rounded border"
                            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'inherit', fontSize: '1em' }}
                          >
                            {content}
                          </pre>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
        </AuthLayout>
    );
}
function mapStateToProps(state) {
    const { token } = state.auth;
    
    const { message, messageType } = state.message;
    return {
        token,
        message,
        messageType,
    };
}

export default connect(mapStateToProps)(ResourcesSocial);
